import {comMapping} from '../../../util/Function/comMapping.js'
export default{
searchlist: [{
		prop: "createTime",
		label: '上传时间',
		type: "datetimerange",
		valueformat:'yyyy-MM-dd hh:mm:ss'
	},
	{
		prop: "batchNo",
		label: '批次号',
		type: "input"
	},
	{
		prop: "fileName",
		label: '原文件名',
		type: "input"
	},
	{
		prop: "result",
		label: '导入结果',
		type: "select",
		selectval:comMapping.$resultlist
	},
	{
		prop: "updateBy",
		label: '操作人',
		type: "input"
	},

],
searchdata:{
	createTime:[],
	batchNo:"",
	fileName:"",
	result:"",
	updateBy:"",
},
headData:[
	{
		title: "上传时间",
		prop: "createTime",
		width:160,align:"left"
	},
	{
		title: "批次号",
		prop: "batchNo",
		width:160,align:"left"
	},
	{
		title: "公司代码",
		prop: "companyCode",
		// custom:true,
		width:80
	},
	{
		title: "公司名称",
		prop: "companyName",
		// custom:true,
		width:160,align:"left"
	},
	{
		title: "原文件名",
		prop: "fileName",
		custom:true,
		width:160,align:"left"
	},
	{
		title: "导入结果",
		prop: "result",
		custom:true,
		width:110
	},
	{
		title: "成功条数",
		prop: "rightCount",
		width:80
	},
	{
		title: "失败条数",
		prop: "errorCount",
		custom:true,
		width:80
	},
	{
		title: "最近操作人",
		prop: "createBy",
		width:90
	},
],
pagination:{
	pageNum: 1,
	pageSize: 50,
	total: 0,
	paginationkey:0
},
}
